import React, { useState } from "react";
import MoneySuccess from "../../../assets/images/moneySuccess.png";
import Award from "../../../assets/images/Award.png";
import Logo from "../../../assets/images/logo.jpg";
import { Loader } from "../../loader";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { claimStatus } from "../../auth/redux/store";
import Header from "../../layout/Header";
import Wrongotp from "../../../assets/images/wrongotp.png";
import { getTransferErrorMessage } from "../../../utils/paymentResponse";


export const TransferFailed = () => {
    const { t, i18n } = useTranslation();
    const { lang } = useParams();
    const transferSuccessTextWithBreak = t("transferSuccessText").replace(
        "<br>",
        "<br>"
    );
    const [loading, setLoading] = useState(false);
    const finalData = useSelector((state) => state?.finalresponse);
    const amount = useSelector((state) => state?.amount);
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const errorMessage = getTransferErrorMessage(finalData);
    dispatch(claimStatus(false));

    return (
        <>
            <Header />
            <div className="main">
                <div className="container p-0">
                    {loading && <Loader />}
                    <div className="card border-0">
                        <div className="card-body px-2 pt-0 pb-2">
                            <div className="px-4 py-2 mt-5 text-center">

                                <img src={Wrongotp} alt="Wrong OTP" className="d-block m-auto LogoImg" />

                                <h3 className="mb-5 mt-4 text-center font-extrabold text-primaryColor">
                                    {amount && (<>₹ {amount}</>)}  
                                </h3>

                                {/* <h3>{finalData.secondaryMessage}</h3> */}
                                <h6 className="font-extrabold">भुगतान विफलता</h6>
                                <p>
                                    {errorMessage || t('notProcess')}
                                </p>


                                <div className="btn btn-secondary btnshadow bottom-fixed-container " onClick={() => navigate(`/${lang}/giftHistory`)}>
                                    दोबारा कोशिश करें
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};
